import React from 'react';
import { motion } from 'framer-motion';
export function TeamSection() {
  return <section className="py-12 md:py-16 bg-slate-900 overflow-hidden relative" data-id="element-338">
      {/* Subtle top/bottom border effect using a gradient line */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-steel-500/30 to-transparent" data-id="element-339" />
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-steel-500/30 to-transparent" data-id="element-340" />

      <div className="max-w-4xl mx-auto px-6 text-center" data-id="element-341">
        <motion.p initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-xs md:text-sm font-semibold tracking-widest uppercase text-steel-400 mb-6" data-id="element-342">
          Our Credentials
        </motion.p>

        <motion.p initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6,
        delay: 0.15
      }} className="text-lg md:text-xl lg:text-2xl font-heading font-medium text-gray-300 leading-relaxed" data-id="element-343">
          Built by former brokerage operators. Our team comes from Thatch &
          Ramp, where we scaled systems and automated tens of thousands of ACA
          enrollments and carrier payments.
        </motion.p>
      </div>
    </section>;
}